import { payApi } from 'yxt-biz-pc/packages/api';

/**
 * 获取卡消费订单信息
 * @param {String} orderId 订单id
 * @returns {Promise} 订单信息
 */
export const getOrderInfo = orderId => {
  return payApi.get(`order/${orderId}`);
};
